/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useRef, useState, useEffect } from 'react';
import {
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Button,
  Select,
  CheckboxGroup,
  Stack,
  Text,
  Box,
  Tooltip,
  RadioGroup,
  Radio,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Divider,
  // Progress,
  useColorModeValue,
  Textarea,
  Flex,
  Stepper,
  Step,
  StepSeparator,
  StepTitle,
  StepNumber,
  StepIcon,
  StepStatus,
  StepIndicator,
  useSteps,
} from '@chakra-ui/react';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import TermsConditions from './TermsConditions';
import { useAuth } from '../contexts/AuthContext';
import TesseramentoFormMinore from './TesseramentoFormMinore';
import { smoothScrollTo } from '../utils';
import HelpSupport from './Tesseramento/HelpRequestModal';
import { trackEvent } from '../utils/umami';

const TesseramentoForm = ({
  isAuthenticated,
  userData,
  onSubmitSuccess,
  isParentRegistration = false,
}) => {
  const { requestUserData } = useAuth();
  const sigCanvas = useRef(null);
  const membershipStartTracked = useRef(false);

  // Helper function to get parent data from first minor child
  const getParentDataFromMinorChild = () => {
    if (!userData?.tesseramenti) return {};

    const minorChild = userData.tesseramenti.find(
      (socio) => socio.isMinorenne === true
    );
    if (!minorChild) return {};

    return {
      nomeGenitore: minorChild.nomeGenitore || '',
      cognomeGenitore: minorChild.cognomeGenitore || '',
      luogoNascitaGenitore: minorChild.luogoNascitaGenitore || '',
      codiceFiscaleGenitore: minorChild.codiceFiscaleGenitore || '',
      dataNascitaGenitore: minorChild.dataNascitaGenitore || '',
      telefono: minorChild.telefono || '',
      indirizzoCitta: minorChild.indirizzoCitta || '',
      indirizzoCap: minorChild.indirizzoCap || '',
    };
  };

  // ----------------------- STATE -----------------------
  const [formData, setFormData] = useState(() => {
    const parentData = isParentRegistration
      ? getParentDataFromMinorChild()
      : {};

    return {
      isMinorenne: isParentRegistration ? false : null, // For parent registration, set as adult
      // Informazioni Generali
      email: userData?.email || '',
      telefono: parentData.telefono || '',
      // Dati del Genitore (per Minorenne)
      nomeGenitore: parentData.nomeGenitore || '',
      cognomeGenitore: parentData.cognomeGenitore || '',
      luogoNascitaGenitore: parentData.luogoNascitaGenitore || '',
      codiceFiscaleGenitore: parentData.codiceFiscaleGenitore || '',
      dataNascitaGenitore: parentData.dataNascitaGenitore || '',
      // Dati del Socio Adulto (per tesseramento genitore, usa i dati del genitore)
      nomeSocio: parentData.nomeGenitore || '', // Pre-fill with parent name for parent registration
      cognomeSocio: parentData.cognomeGenitore || '', // Pre-fill with parent surname for parent registration
      dataNascitaSocio: parentData.dataNascitaGenitore || '',
      luogoNascitaSocio: parentData.luogoNascitaGenitore || '',
      codiceFiscaleSocio: parentData.codiceFiscaleGenitore || '',
      precauzioniSanitarie: '',
      indirizzoVia: '',
      indirizzoCitta: parentData.indirizzoCitta || '',
      indirizzoCap: parentData.indirizzoCap || '',
      // Termini e Interessi
      comeSeiVenutoConoscenza: '',
      interessi: [],
      autorizzazioneFotografie: true,
      consensoPubblicazione: true,
      terminiCondizioni: false,
      sendNewsletter: true,
      data: new Date().toISOString().split('T')[0],
      luogo: '',
      firma: '',
      // Pagamento
      paymentMethod: '', // 'elettronico' o 'contanti'
      paymentStatus: '', // 'succeeded' o 'pending'
      price: 10,
    };
  });

  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  // Keep track of which fields the user has interacted with
  const [touched, setTouched] = useState({});

  const [emailLoading, setEmailLoading] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [paymentError, setPaymentError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [socioCreated, setSocioCreated] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const { activeStep: step, setActiveStep: setStep } = useSteps({
    index: 0, // Always start from step 0
    count: 3,
  });

  // Options as before
  const options = {
    comeSeiVenutoConoscenza: [
      'Rinnovo Tessera',
      'Passaparola',
      'Volantino',
      'Facebook',
      'Instagram',
      'Sito Web',
      'Sede',
      'Altro',
    ],
    interessi: [
      'Giochi di carte',
      'Sport',
      'Giochi da tavolo',
      'Pittura & Disegno',
      'Miniature',
      'Videogiochi',
      'Natura & Animali',
      'Avventure Outdoor',
    ],
  };

  // ================= FIELD-LEVEL VALIDATION =================

  const validateField = (field, value) => {
    let errorMsg = '';

    // Provide your own basic validators
    // Email regex più rigoroso: non permette virgole, spazi, caratteri speciali non validi
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^[0-9+\-()\s]{7,20}$/;

    switch (field) {
      // Step 1 fields
      case 'email':
        if (!value) {
          errorMsg = 'Email è obbligatorio';
        } else if (value.includes(',')) {
          // Controlli aggiuntivi per errori comuni
          errorMsg =
            "L'email non può contenere virgole. Usa un punto (.) invece.";
        } else if (value.includes(' ')) {
          errorMsg = "L'email non può contenere spazi.";
        } else if (!emailRegex.test(value)) {
          errorMsg =
            "Formato email non valido. Verifica di aver inserito correttamente l'indirizzo (es. nome@dominio.com)";
        }
        break;
      case 'telefono':
        if (!value) {
          errorMsg = 'Telefono è obbligatorio';
        } else if (!phoneRegex.test(value)) {
          errorMsg = 'Telefono non valido';
        }
        break;

      // Genitore (Minorenne) fields
      case 'nomeGenitore':
      case 'cognomeGenitore':
      case 'luogoNascitaGenitore':
      case 'codiceFiscaleGenitore':
        if (!value) {
          errorMsg = 'Questo campo è obbligatorio';
        }
        break;
      case 'dataNascitaGenitore':
        if (!value) {
          errorMsg = 'Questo campo è obbligatorio';
        }
        break;

      // Socio Adulto fields
      case 'nomeSocio':
      case 'cognomeSocio':
      case 'luogoNascitaSocio':
      case 'comeSeiVenutoConoscenza':
      case 'codiceFiscaleSocio':
      case 'indirizzoVia':
      case 'indirizzoCitta':
      case 'indirizzoCap':
        if (!value) {
          errorMsg = 'Questo campo è obbligatorio';
        }
        break;
      case 'dataNascitaSocio':
        if (!value) {
          errorMsg = 'Questo campo è obbligatorio';
        }
        break;

      // Termini, data, firma
      case 'terminiCondizioni':
        if (!value) {
          errorMsg = 'Devi accettare i termini e condizioni';
        }
        break;
      case 'luogo':
        if (!value) {
          errorMsg = 'Questo campo è obbligatorio';
        }
        break;
      case 'firma':
        if (!value) {
          errorMsg = 'La firma è obbligatoria';
        }
        break;

      // Payment fields
      case 'paymentMethod':
        if (!value) {
          errorMsg = 'Seleziona un metodo di pagamento';
        }
        break;

      // Default
      default:
        // For optional fields or fields with no checks
        break;
    }

    return errorMsg;
  };

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData((prev) => ({ ...prev, [id]: newValue }));

    // Clear email error if changing email
    if (id === 'email') {
      setEmailError('');
    }

    // If user has touched this field, re-validate it
    // if (touched[id]) {
    // }
    const fieldErr = validateField(id, newValue);

    setErrors((prevErrors) => ({ ...prevErrors, [id]: fieldErr }));
  };

  // Mark the field as touched on blur & do field-level validation
  const handleBlur = (e) => {
    const { id } = e.target;
    setTouched((prev) => ({ ...prev, [id]: true }));

    const fieldErr = validateField(id, formData[id]);
    setErrors((prev) => ({ ...prev, [id]: fieldErr }));
  };

  // ================= STEP-BASED VALIDATION =================
  // The function that checks all the relevant fields for the current step
  // to let the user proceed or finalize the form
  const validateFormForStep = () => {
    const newErrors = {};

    // Checking if signature is empty
    const isSignatureEmpty =
      sigCanvas.current && sigCanvas.current.isEmpty
        ? sigCanvas.current.isEmpty()
        : true;

    // Step-based checks from your original code:
    if (step === 0) {
      if (!isParentRegistration && formData.isMinorenne === null) {
        newErrors.socioType = 'Seleziona il tipo di socio';
      }
      if (!formData.email) {
        newErrors.email = 'Email è obbligatorio';
      } else if (formData.email.includes(',')) {
        // Controlli aggiuntivi per errori comuni
        newErrors.email =
          "L'email non può contenere virgole. Usa un punto (.) invece.";
      } else if (formData.email.includes(' ')) {
        newErrors.email = "L'email non può contenere spazi.";
      } else {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(formData.email)) {
          newErrors.email =
            "Formato email non valido. Verifica di aver inserito correttamente l'indirizzo (es. nome@dominio.com)";
        }
      }
      if (!formData.telefono) {
        newErrors.telefono = 'Telefono è obbligatorio';
      } else {
        const phoneRegex = /^[0-9+\-()\s]{7,20}$/;
        if (!phoneRegex.test(formData.telefono)) {
          newErrors.telefono = 'Telefono non valido';
        }
      }
    } else if (step === 1) {
      if (formData.isMinorenne) {
        // Genitore
        if (!formData.nomeGenitore) {
          newErrors.nomeGenitore = 'Questo campo è obbligatorio';
        }
        if (!formData.cognomeGenitore) {
          newErrors.cognomeGenitore = 'Questo campo è obbligatorio';
        }
        if (!formData.luogoNascitaGenitore) {
          newErrors.luogoNascitaGenitore = 'Questo campo è obbligatorio';
        }
        if (!formData.codiceFiscaleGenitore) {
          newErrors.codiceFiscaleGenitore = 'Questo campo è obbligatorio';
        }
        if (!formData.dataNascitaGenitore) {
          newErrors.dataNascitaGenitore = 'Questo campo è obbligatorio';
        }
      } else {
        // Adult
        if (!formData.nomeSocio) {
          newErrors.nomeSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.cognomeSocio) {
          newErrors.cognomeSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.dataNascitaSocio) {
          newErrors.dataNascitaSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.luogoNascitaSocio) {
          newErrors.luogoNascitaSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.codiceFiscaleSocio) {
          newErrors.codiceFiscaleSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.indirizzoVia) {
          newErrors.indirizzoVia = 'Questo campo è obbligatorio';
        }
        if (!formData.indirizzoCitta) {
          newErrors.indirizzoCitta = 'Questo campo è obbligatorio';
        }
        if (!formData.indirizzoCap) {
          newErrors.indirizzoCap = 'Questo campo è obbligatorio';
        }
      }
    } else if (step === 2) {
      if (formData.isMinorenne) {
        // Socio Minore
        if (!formData.nomeSocio) {
          newErrors.nomeSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.cognomeSocio) {
          newErrors.cognomeSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.dataNascitaSocio) {
          newErrors.dataNascitaSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.luogoNascitaSocio) {
          newErrors.luogoNascitaSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.codiceFiscaleSocio) {
          newErrors.codiceFiscaleSocio = 'Questo campo è obbligatorio';
        }
        if (!formData.indirizzoVia) {
          newErrors.indirizzoVia = 'Questo campo è obbligatorio';
        }
        if (!formData.indirizzoCitta) {
          newErrors.indirizzoCitta = 'Questo campo è obbligatorio';
        }
        if (!formData.indirizzoCap) {
          newErrors.indirizzoCap = 'Questo campo è obbligatorio';
        }
      } else {
        // Termini, Data e Firma per Socio Adulto
        if (!formData.terminiCondizioni) {
          newErrors.terminiCondizioni = 'Devi accettare i termini e condizioni';
        }
        if (!formData.luogo) {
          newErrors.luogo = 'Questo campo è obbligatorio';
        }
        if (!formData.comeSeiVenutoConoscenza) {
          newErrors.comeSeiVenutoConoscenza = 'Questo campo è obbligatorio';
        }
        if (!formData.firma && isSignatureEmpty) {
          newErrors.firma = 'La firma è obbligatoria';
        }
      }
    } else if (step === 3) {
      if (formData.isMinorenne) {
        // Termini, Data e Firma per Socio Minorenne
        if (!formData.terminiCondizioni) {
          newErrors.terminiCondizioni = 'Devi accettare i termini e condizioni';
        }
        if (!formData.comeSeiVenutoConoscenza) {
          newErrors.comeSeiVenutoConoscenza = 'Questo campo è obbligatorio';
        }
        if (!formData.luogo) {
          newErrors.luogo = 'Questo campo è obbligatorio';
        }
        if (!formData.firma && isSignatureEmpty) {
          newErrors.firma = 'La firma è obbligatoria';
        }
      } else {
        // Pagamento Socio Adulto
        if (!formData.paymentMethod) {
          newErrors.paymentMethod = 'Seleziona un metodo di pagamento';
        }
        if (formData.paymentMethod === 'elettronico' && paymentError) {
          newErrors.paymentError = paymentError;
        }
      }
    }

    setErrors(newErrors);
    const valid = Object.keys(newErrors).every((e) => !newErrors[e]);
    setIsFormValid(valid);
    return valid;
  };
  // ================= END STEP-BASED VALIDATION =================

  // =================== MISC HANDLERS ===================
  const handleMinorenneSwitch = (value) => {
    const isMinorenne = value === 'minorenne';
    setFormData((prevData) => ({
      ...prevData,
      isMinorenne,
      nomeGenitore: '',
      cognomeGenitore: '',
      luogoNascitaGenitore: '',
      codiceFiscaleGenitore: '',
      dataNascitaGenitore: '',
      nomeSocio: '',
      cognomeSocio: '',
      dataNascitaSocio: '',
      luogoNascitaSocio: '',
      codiceFiscaleSocio: '',
      precauzioniSanitarie: '',
      indirizzoVia: '',
      indirizzoCitta: '',
      indirizzoCap: '',
    }));

    // If user has touched this field, re-validate it
    const fieldErr = validateField('isMinorenne', isMinorenne);

    const errorsUpdate = { ...errors, isMinorenne: fieldErr };

    if (fieldErr) {
      setErrors((prevErrors) => ({ ...prevErrors, isMinorenne: fieldErr }));
    }

    const valid = Object.keys(errorsUpdate).every((e) => !errorsUpdate[e]);

    setIsFormValid(valid);
  };

  const handleInteressiChange = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      interessi: selectedOptions,
    }));
  };

  const clearSignature = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
    setFormData((prevData) => ({ ...prevData, firma: '' }));
  };

  const onHelpSupportModalClose = () => {
    setIsHelpModalOpen(false);
  };

  useEffect(() => {
    if (
      (step === 2 && !formData.isMinorenne) ||
      (step === 3 && formData.isMinorenne)
    ) {
      if (formData.firma && sigCanvas.current) {
        sigCanvas.current.fromDataURL(formData.firma);
      }
    }

    setTimeout(() => {
      const ordiniTitle = document.getElementsByClassName(
        'tesseramento-form-first-input'
      );

      if (ordiniTitle[0]) {
        const offset = window.innerWidth < 769 ? 130 : 270; // Adjust offset as needed
        const elementPosition =
          ordiniTitle[0].getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;
        smoothScrollTo(offsetPosition, 200);
      }
    }, 200);

    const valid =
      Object.keys(errors).length &&
      Object.keys(errors).every((e) => !errors[e]);

    setIsFormValid(valid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    const valid =
      Object.keys(errors).length &&
      Object.keys(errors).every((err) => !errors[err]);
    setIsFormValid(valid);
  }, [errors]);

  const { isAuthenticated: isAuth } = useAuth();
  useEffect(() => {
    if (isAuth && !socioCreated?.documentId && !isParentRegistration) {
      handleMinorenneSwitch('minorenne');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  // =================== EMAIL CHECK ======================
  const checkEmail = async (emailValue, callback) => {
    if (!emailValue) return;
    setEmailLoading(true);
    try {
      await axios.post('/api/cmil', { e: emailValue });
    } catch (err) {
      if (err.response?.status === 401) {
        if (err.response?.data?.exists) {
          setEmailError('This email is already registered.');
        } else {
          setEmailError('');
          callback({ emailVerified: true });
        }
      }
    } finally {
      setEmailLoading(false);
    }
  };

  // =================== STEP CONTROLS ====================
  const handleNext = async ({ emailVerified } = {}) => {
    setPaymentError('');

    // Step 1: check email duplication if needed
    if (step === 0 && !isParentRegistration && !emailError && !emailVerified) {
      await checkEmail(formData.email, () => {
        handleNext({ emailVerified: true });
      });
      return;
    }

    // If leaving the step that requires signature
    if (
      (step === 2 && !formData.isMinorenne) ||
      (step === 3 && formData.isMinorenne)
    ) {
      if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
        const signature = sigCanvas.current
          .getTrimmedCanvas()
          .toDataURL('image/png');
        setFormData((prevData) => ({ ...prevData, firma: signature }));
      } else {
        setFormData((prevData) => ({ ...prevData, firma: '' }));
      }
    }

    const valid = validateFormForStep();
    if (!valid) return;

    if (
      (step === 2 && !formData.isMinorenne) ||
      (step === 3 && formData.isMinorenne)
    ) {
      handleSubmit();
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  // =================== SUBMIT ====================
  const handleSubmit = async (e = {}) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    const valid = validateFormForStep();
    if (!valid) return;

    // Un solo inizio per compilazione, anche se l'invio viene ritentato
    if (!membershipStartTracked.current) {
      membershipStartTracked.current = true;
      trackEvent('membership_start', { flow: 'nuovo' });
    }

    setLoading(true);
    setPaymentError(null);

    const dataToSubmit = { ...formData, user: formData.email };

    // If we have a signature, store it again
    if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
      dataToSubmit.firma = sigCanvas.current
        .getTrimmedCanvas()
        .toDataURL('image/png');
    }

    dataToSubmit.paymentStatus = 'pending';

    try {
      const response = await fetch('/api/tesseramento', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSubmit),
      });

      const jsonResponse = await response.json();
      if (!response.ok) {
        // Intercetta errori di validazione email dal backend
        if (
          jsonResponse.error?.error?.name === 'ValidationError' &&
          jsonResponse.error?.error?.details?.errors?.some((err) =>
            err.path?.includes('email')
          )
        ) {
          setErrors((prev) => ({
            ...prev,
            email:
              'Email non valida. Verifica il formato (es. nome@dominio.com)',
          }));
          setStep(0); // Torna al primo step
          setLoading(false);
          // Scroll al campo email
          setTimeout(() => {
            const emailField = document.getElementsByClassName(
              'tesseramento-form-first-input'
            )[0];
            if (emailField) {
              const offset = window.innerWidth < 769 ? 130 : 270;
              const elementPosition =
                emailField.getBoundingClientRect().top + window.scrollY;
              const offsetPosition = elementPosition - offset;
              smoothScrollTo(offsetPosition, 200);
            }
          }, 100);
          return;
        }
        throw new Error(
          `Errore nella sottomissione del form: ${jsonResponse.message}`
        );
      }

      setTimeout(() => {
        if (onSubmitSuccess) {
          onSubmitSuccess();
        }

        setSocioCreated(jsonResponse.socio);
        setSubmissionStatus('success');
        requestUserData({ withLoading: false });
        setLoading(false);

        smoothScrollTo(0, 200);
      }, 1000);
    } catch (error) {
      console.error('Errore nella sottomissione del form:', error);

      // Intercetta errori di validazione email dal backend (anche se nel message come stringa JSON)
      const errorMessage = error.message || '';
      const isEmailError =
        errorMessage.includes('email must be a valid email') ||
        errorMessage.includes('ValidationError') ||
        errorMessage.includes("Errore nella registrazione dell'utente");

      if (isEmailError) {
        try {
          // Prova a parsare il JSON dal message se presente
          const jsonMatch = errorMessage.match(/\{[\s\S]*\}/);
          if (jsonMatch) {
            const parsedError = JSON.parse(jsonMatch[0]);
            if (
              parsedError.error?.name === 'ValidationError' &&
              parsedError.error?.details?.errors?.some((err) =>
                err.path?.includes('email')
              )
            ) {
              const emailValidationError =
                parsedError.error.details.errors.find((err) =>
                  err.path?.includes('email')
                );
              const errorValue = emailValidationError?.value || '';
              let errorMsg =
                'Email non valida. Verifica il formato (es. nome@dominio.com)';

              // Messaggi più specifici in base all'errore
              if (errorValue.includes(',')) {
                errorMsg =
                  "L'email non può contenere virgole. Usa un punto (.) invece.";
              } else if (errorValue.includes(' ')) {
                errorMsg = "L'email non può contenere spazi.";
              }

              setErrors((prev) => ({ ...prev, email: errorMsg }));
              setStep(0); // Torna al primo step
              setLoading(false);
              // Scroll al campo email
              setTimeout(() => {
                const emailField = document.getElementsByClassName(
                  'tesseramento-form-first-input'
                )[0];
                if (emailField) {
                  const offset = window.innerWidth < 769 ? 130 : 270;
                  const elementPosition =
                    emailField.getBoundingClientRect().top + window.scrollY;
                  const offsetPosition = elementPosition - offset;
                  smoothScrollTo(offsetPosition, 200);
                }
              }, 100);
              return;
            }
          }
        } catch (parseError) {
          // Se il parsing fallisce, controlla comunque se c'è un riferimento all'email
          if (errorMessage.toLowerCase().includes('email')) {
            setErrors((prev) => ({
              ...prev,
              email:
                'Email non valida. Verifica il formato (es. nome@dominio.com)',
            }));
            setStep(0);
            setLoading(false);
            // Scroll al campo email
            setTimeout(() => {
              const emailField = document.getElementsByClassName(
                'tesseramento-form-first-input'
              )[0];
              if (emailField) {
                const offset = window.innerWidth < 769 ? 130 : 270;
                const elementPosition =
                  emailField.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - offset;
                smoothScrollTo(offsetPosition, 200);
              }
            }, 100);
            return;
          }
        }
      }

      setSubmissionStatus('error');
      setLoading(false);
    }
  };

  const handleHelpRequest = () => {
    setIsHelpModalOpen(true);
  };

  // Steps
  const totalSteps = formData.isMinorenne ? 5 : 4;

  const formLabelColor = useColorModeValue('black', 'white');
  const formTextColor = useColorModeValue('black', 'white');

  if (isAuthenticated && !socioCreated?.documentId && !isParentRegistration) {
    return (
      <TesseramentoFormMinore
        isAuthenticated={isAuthenticated}
        userData={userData}
        onSubmitSuccess={onSubmitSuccess}
      />
    );
  }

  return (
    <Box
      p={{ base: 4, md: 8 }}
      maxW="600px"
      mx="auto"
      width="100%"
      mt={12}
      mb={14}
      borderRadius={8}
      boxShadow="20px 20px 60px #bebebe, -20px -20px 60px #ffffff"
      style={
        submissionStatus === 'success'
          ? {
              background: '#c6f6d5',
            }
          : {
              background: 'linear-gradient(315deg,rgb(231, 240, 248), #edf2f7)',
            }
      }
    >
      {isParentRegistration && (
        <Box mb={6} textAlign="center">
          <Text fontSize="xl" fontWeight="bold" color="blue.600">
            Tesseramento Genitore
          </Text>
          <Text fontSize="sm" color="gray.600" mt={2}>
            Completa il tuo tesseramento utilizzando i dati già inseriti per il
            figlio minore
          </Text>
        </Box>
      )}
      {submissionStatus === 'success' ? (
        <Alert status="success">
          <AlertDescription textAlign="left">
            <b>Congratulazioni!</b> Il tesseramento è stato completato con
            successo.
            <br />
            <br />
            <b>Controlla la tua email</b>: troverai una password temporanea per
            accedere all&apos;area riservata.
            <br />
            <br />
            Dopo il login, potrai procedere con il pagamento della tessera.
          </AlertDescription>
        </Alert>
      ) : (
        <>
          <Stepper index={step} colorScheme="yellow">
            {[
              { title: 'Step 1' },
              ...(formData.isMinorenne
                ? [{ title: 'Step 2' }, { title: 'Step 3' }]
                : [{ title: 'Step 2' }]),
              { title: 'Conferma' },
            ].map((st) => (
              <Step key={st.title}>
                <StepIndicator>
                  <StepStatus
                    complete={<StepIcon />}
                    incomplete={<StepNumber />}
                    active={<StepNumber />}
                  />
                </StepIndicator>

                {window.innerWidth < 788 ? null : (
                  <Box flexShrink="0">
                    <StepTitle>{st.title}</StepTitle>
                  </Box>
                )}

                <StepSeparator />
              </Step>
            ))}
          </Stepper>
          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch" mt={8}>
              {/** ---------------- STEP 1 ---------------- */}
              {step === 0 && (
                <>
                  <FormControl
                    mb={3}
                    id="email"
                    isRequired
                    isInvalid={Boolean(errors.email)}
                  >
                    <FormLabel
                      fontWeight="600"
                      color={formLabelColor}
                      className="tesseramento-form-first-input"
                    >
                      Email (sarà il tuo username)
                    </FormLabel>
                    <Input
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      color={formTextColor}
                      borderColor="blue.400"
                      isReadOnly={isParentRegistration}
                      bg={isParentRegistration ? 'gray.100' : 'white'}
                      data-testid="tesseramento-form-email"
                    />
                    {isParentRegistration && (
                      <Text
                        color="gray.500"
                        fontSize="sm"
                        textAlign="left"
                        pt={1}
                      >
                        Email dell&apos;account esistente (non modificabile)
                      </Text>
                    )}
                    {errors.email && (
                      <Text
                        color="red.500"
                        fontSize="sm"
                        textAlign="right"
                        pt={2}
                      >
                        {errors.email}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    mb={3}
                    id="telefono"
                    isRequired
                    isInvalid={Boolean(errors.telefono)}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Recapito Telefonico
                    </FormLabel>
                    <Input
                      type="tel"
                      value={formData.telefono}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      color={formTextColor}
                      borderColor="blue.400"
                    />
                    {errors.telefono && (
                      <Text
                        color="red.500"
                        fontSize="sm"
                        textAlign="right"
                        pt={2}
                      >
                        {errors.telefono}
                      </Text>
                    )}
                  </FormControl>

                  {!isAuthenticated && !isParentRegistration && (
                    <FormControl
                      mb={3}
                      isRequired
                      isInvalid={Boolean(errors.socioType)}
                    >
                      <FormLabel fontWeight="600" color={formLabelColor}>
                        Tipo di Socio da tesserare
                      </FormLabel>
                      <RadioGroup
                        onChange={handleMinorenneSwitch}
                        value={
                          formData.isMinorenne
                            ? 'minorenne'
                            : formData.isMinorenne === false
                              ? 'adulto'
                              : ''
                        }
                      >
                        <HStack spacing={4}>
                          <Radio
                            colorScheme="teal"
                            value="adulto"
                            borderColor="blue.400"
                          >
                            Adulto
                          </Radio>
                          <Radio
                            colorScheme="teal"
                            value="minorenne"
                            borderColor="blue.400"
                          >
                            Minorenne
                          </Radio>
                        </HStack>
                      </RadioGroup>
                      {errors.socioType && (
                        <Text
                          color="red.500"
                          fontSize="sm"
                          textAlign="left"
                          pt={2}
                        >
                          {errors.socioType}
                        </Text>
                      )}
                    </FormControl>
                  )}
                </>
              )}

              {/** ---------------- STEP 2 ---------------- */}
              {step === 1 && (
                <>
                  {formData.isMinorenne ? (
                    <>
                      <FormControl
                        mb={3}
                        id="nomeGenitore"
                        isRequired
                        isInvalid={Boolean(errors.nomeGenitore)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Nome Genitore/Tutore legale
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.nomeGenitore}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                          className="tesseramento-form-first-input"
                        />
                        {errors.nomeGenitore && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.nomeGenitore}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="cognomeGenitore"
                        isRequired
                        isInvalid={Boolean(errors.cognomeGenitore)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Cognome Genitore/Tutore legale
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.cognomeGenitore}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.cognomeGenitore && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.cognomeGenitore}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="dataNascitaGenitore"
                        isRequired
                        isInvalid={Boolean(errors.dataNascitaGenitore)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Data di Nascita Genitore/Tutore legale
                        </FormLabel>
                        <Input
                          type="date"
                          value={formData.dataNascitaGenitore}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.dataNascitaGenitore && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.dataNascitaGenitore}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="luogoNascitaGenitore"
                        isRequired
                        isInvalid={Boolean(errors.luogoNascitaGenitore)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Luogo di Nascita Genitore/Tutore legale
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.luogoNascitaGenitore}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.luogoNascitaGenitore && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.luogoNascitaGenitore}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="codiceFiscaleGenitore"
                        isRequired
                        isInvalid={Boolean(errors.codiceFiscaleGenitore)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Codice Fiscale Genitore/Tutore legale
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.codiceFiscaleGenitore}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.codiceFiscaleGenitore && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.codiceFiscaleGenitore}
                          </Text>
                        )}
                      </FormControl>
                    </>
                  ) : (
                    <>
                      <Flex>
                        <FormControl
                          mb={3}
                          id="nomeSocio"
                          isRequired
                          isInvalid={Boolean(errors.nomeSocio)}
                          marginRight={4}
                        >
                          <FormLabel fontWeight="600" color={formLabelColor}>
                            Nome
                          </FormLabel>
                          <Input
                            type="text"
                            value={formData.nomeSocio}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            color={formTextColor}
                            borderColor="blue.400"
                            className="tesseramento-form-first-input"
                          />
                          {errors.nomeSocio && (
                            <Text
                              color="red.500"
                              fontSize="sm"
                              textAlign="right"
                              pt={2}
                            >
                              {errors.nomeSocio}
                            </Text>
                          )}
                        </FormControl>

                        <FormControl
                          mb={3}
                          id="cognomeSocio"
                          isRequired
                          isInvalid={Boolean(errors.cognomeSocio)}
                        >
                          <FormLabel fontWeight="600" color={formLabelColor}>
                            Cognome
                          </FormLabel>
                          <Input
                            type="text"
                            value={formData.cognomeSocio}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            color={formTextColor}
                            borderColor="blue.400"
                          />
                          {errors.cognomeSocio && (
                            <Text
                              color="red.500"
                              fontSize="sm"
                              textAlign="right"
                              pt={2}
                            >
                              {errors.cognomeSocio}
                            </Text>
                          )}
                        </FormControl>
                      </Flex>

                      <FormControl
                        mb={3}
                        id="dataNascitaSocio"
                        isRequired
                        isInvalid={Boolean(errors.dataNascitaSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Data di Nascita
                        </FormLabel>
                        <Input
                          type="date"
                          value={formData.dataNascitaSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.dataNascitaSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.dataNascitaSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="luogoNascitaSocio"
                        isRequired
                        isInvalid={Boolean(errors.luogoNascitaSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Luogo di Nascita
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.luogoNascitaSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.luogoNascitaSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.luogoNascitaSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="codiceFiscaleSocio"
                        isRequired
                        isInvalid={Boolean(errors.codiceFiscaleSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Codice Fiscale
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.codiceFiscaleSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.codiceFiscaleSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.codiceFiscaleSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="indirizzoVia"
                        isRequired
                        isInvalid={Boolean(errors.indirizzoVia)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (Via)
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.indirizzoVia}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.indirizzoVia && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.indirizzoVia}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="indirizzoCitta"
                        isRequired
                        isInvalid={Boolean(errors.indirizzoCitta)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (Città)
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.indirizzoCitta}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.indirizzoCitta && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.indirizzoCitta}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="indirizzoCap"
                        isRequired
                        isInvalid={Boolean(errors.indirizzoCap)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (CAP)
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.indirizzoCap}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.indirizzoCap && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.indirizzoCap}
                          </Text>
                        )}
                      </FormControl>
                    </>
                  )}
                </>
              )}

              {/** ---------------- STEP 3 ---------------- */}
              {step === 2 && (
                <>
                  {formData.isMinorenne ? (
                    <>
                      <FormControl
                        mb={3}
                        id="nomeSocio"
                        isRequired
                        isInvalid={Boolean(errors.nomeSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Nome Socio Minore
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.nomeSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                          className="tesseramento-form-first-input"
                        />
                        {errors.nomeSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.nomeSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="cognomeSocio"
                        isRequired
                        isInvalid={Boolean(errors.cognomeSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Cognome Socio Minore
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.cognomeSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.cognomeSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.cognomeSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="dataNascitaSocio"
                        isRequired
                        isInvalid={Boolean(errors.dataNascitaSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Data di Nascita Socio Minore
                        </FormLabel>
                        <Input
                          type="date"
                          value={formData.dataNascitaSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.dataNascitaSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.dataNascitaSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="luogoNascitaSocio"
                        isRequired
                        isInvalid={Boolean(errors.luogoNascitaSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Luogo di Nascita Socio Minore
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.luogoNascitaSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.luogoNascitaSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.luogoNascitaSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="codiceFiscaleSocio"
                        isRequired
                        isInvalid={Boolean(errors.codiceFiscaleSocio)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Codice Fiscale Socio Minore
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.codiceFiscaleSocio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.codiceFiscaleSocio && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.codiceFiscaleSocio}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="indirizzoVia"
                        isRequired
                        isInvalid={Boolean(errors.indirizzoVia)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (Via)
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.indirizzoVia}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.indirizzoVia && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.indirizzoVia}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="indirizzoCitta"
                        isRequired
                        isInvalid={Boolean(errors.indirizzoCitta)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (Città)
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.indirizzoCitta}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.indirizzoCitta && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.indirizzoCitta}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="indirizzoCap"
                        isRequired
                        isInvalid={Boolean(errors.indirizzoCap)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (CAP)
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.indirizzoCap}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.indirizzoCap && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.indirizzoCap}
                          </Text>
                        )}
                      </FormControl>
                    </>
                  ) : (
                    <>
                      <FormControl
                        mb={3}
                        id="precauzioniSanitarie"
                        isInvalid={Boolean(errors.precauzioniSanitarie)}
                      >
                        <FormLabel
                          fontWeight="600"
                          color={formLabelColor}
                          className="tesseramento-form-first-input"
                        >
                          Precauzioni Sanitarie
                        </FormLabel>
                        <Textarea
                          value={formData.precauzioniSanitarie}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.precauzioniSanitarie && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.precauzioniSanitarie}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="comeSeiVenutoConoscenza"
                        isRequired
                        isInvalid={Boolean(errors.comeSeiVenutoConoscenza)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Come Sei Venuto a Conoscenza
                        </FormLabel>
                        <Select
                          placeholder="Seleziona opzione"
                          value={formData.comeSeiVenutoConoscenza}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        >
                          {options.comeSeiVenutoConoscenza.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </Select>
                        {errors.comeSeiVenutoConoscenza && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.comeSeiVenutoConoscenza}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="interessi"
                        isInvalid={Boolean(errors.interessi)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Interessi
                        </FormLabel>
                        <CheckboxGroup
                          value={formData.interessi}
                          onChange={handleInteressiChange}
                        >
                          <Stack spacing={2} direction="column">
                            {options.interessi.map((option) => (
                              <Checkbox
                                key={option}
                                value={option}
                                borderColor="blue.300"
                              >
                                {option}
                              </Checkbox>
                            ))}
                          </Stack>
                        </CheckboxGroup>
                        {errors.interessi && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.interessi}
                          </Text>
                        )}
                      </FormControl>

                      <Divider />
                      <FormControl
                        mb={3}
                        id="autorizzazioneFotografie"
                        isInvalid={Boolean(errors.autorizzazioneFotografie)}
                      >
                        <Checkbox
                          id="autorizzazioneFotografie"
                          isChecked={formData.autorizzazioneFotografie}
                          onChange={handleChange}
                          borderColor="blue.300"
                        >
                          <Text
                            display="inline"
                            color={formTextColor}
                            borderColor="blue.400"
                          >
                            Autorizzazione Fotografie
                          </Text>
                          <Tooltip
                            label="Consente l'utilizzo e la pubblicazione delle tue fotografie per scopi di archivio e documentazione delle attività."
                            fontSize="sm"
                            hasArrow
                          >
                            <Text
                              as="span"
                              ml={2}
                              color="gray.500"
                              cursor="pointer"
                            >
                              ?
                            </Text>
                          </Tooltip>
                        </Checkbox>
                        {errors.autorizzazioneFotografie && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="center"
                            pt={2}
                          >
                            {errors.autorizzazioneFotografie}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="consensoPubblicazione"
                        isInvalid={Boolean(errors.consensoPubblicazione)}
                      >
                        <Checkbox
                          id="consensoPubblicazione"
                          isChecked={formData.consensoPubblicazione}
                          onChange={handleChange}
                          borderColor="blue.300"
                        >
                          <Text
                            display="inline"
                            color={formTextColor}
                            borderColor="blue.400"
                          >
                            Consenso Pubblicazione
                          </Text>
                          <Tooltip
                            label="Acconsenti alla pubblicazione delle fotografie e contenuti multimediali quali audio e video sul web e sui social."
                            fontSize="sm"
                            hasArrow
                          >
                            <Text
                              as="span"
                              ml={2}
                              color="gray.500"
                              cursor="pointer"
                            >
                              ?
                            </Text>
                          </Tooltip>
                        </Checkbox>
                        {errors.consensoPubblicazione && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="center"
                            pt={2}
                          >
                            {errors.consensoPubblicazione}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="sendNewsletter"
                        isInvalid={Boolean(errors.sendNewsletter)}
                      >
                        <Checkbox
                          id="sendNewsletter"
                          isChecked={formData.sendNewsletter}
                          onChange={handleChange}
                          borderColor="blue.300"
                        >
                          <Text
                            display="inline"
                            color={formTextColor}
                            borderColor="blue.400"
                          >
                            Iscriviti alla newsletter di CIL!
                          </Text>
                          <Tooltip
                            label="Rimani aggiornato su tutti i nostri eventi e iniziative."
                            fontSize="sm"
                            hasArrow
                          >
                            <Text
                              as="span"
                              ml={2}
                              color="gray.500"
                              cursor="pointer"
                            >
                              ?
                            </Text>
                          </Tooltip>
                        </Checkbox>
                        {errors.sendNewsletter && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="center"
                            pt={2}
                          >
                            {errors.sendNewsletter}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="terminiCondizioni"
                        isInvalid={Boolean(errors.terminiCondizioni)}
                      >
                        <Checkbox
                          id="terminiCondizioni"
                          isChecked={formData.terminiCondizioni}
                          onChange={handleChange}
                          borderColor="blue.300"
                        >
                          <Text color={formTextColor} borderColor="blue.400">
                            Termini e Condizioni
                          </Text>
                        </Checkbox>
                        {errors.terminiCondizioni && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="center"
                            pt={2}
                          >
                            {errors.terminiCondizioni}
                          </Text>
                        )}
                      </FormControl>

                      <TermsConditions />

                      <Divider />

                      <FormControl
                        mb={3}
                        id="data"
                        isRequired
                        isInvalid={Boolean(errors.data)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Data
                        </FormLabel>
                        <Input
                          type="date"
                          value={formData.data}
                          isReadOnly
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.data && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.data}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="luogo"
                        isRequired
                        isInvalid={Boolean(errors.luogo)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Luogo
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.luogo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.luogo && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.luogo}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="firma"
                        isRequired
                        isInvalid={Boolean(errors.firma)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Firma
                        </FormLabel>
                        <SignatureCanvas
                          ref={sigCanvas}
                          clearOnResize={false}
                          penColor={useColorModeValue('black', 'white')}
                          canvasProps={{
                            style: {
                              width: '100%',
                              height: '150px',
                              border: '1px solid #dddddd',
                              borderRadius: '8px',
                              backgroundColor: useColorModeValue(
                                'white',
                                'gray.700'
                              ),
                            },
                            className: 'sigCanvas',
                          }}
                          onEnd={() => {
                            if (touched.firma) {
                              // Re-validate if the user has interacted
                              const fieldErr = validateField(
                                'firma',
                                formData.firma
                              );
                              setErrors((prev) => ({
                                ...prev,
                                firma: fieldErr,
                              }));
                            }
                          }}
                        />
                        <Button
                          mt={2}
                          mb={2}
                          width="full"
                          onClick={clearSignature}
                          size="sm"
                          colorScheme="teal"
                        >
                          Ripristina Firma
                        </Button>
                        {errors.firma && (
                          <Text
                            textAlign="center"
                            color="red.500"
                            fontSize="sm"
                          >
                            {errors.firma}
                          </Text>
                        )}
                      </FormControl>
                    </>
                  )}
                </>
              )}

              {/** ---------------- STEP 4 ---------------- */}
              {step === 3 && (
                <>
                  {formData.isMinorenne && (
                    <>
                      <FormControl
                        mb={3}
                        id="precauzioniSanitarie"
                        isInvalid={Boolean(errors.precauzioniSanitarie)}
                      >
                        <FormLabel
                          fontWeight="600"
                          color={formLabelColor}
                          className="tesseramento-form-first-input"
                        >
                          Precauzioni Sanitarie
                        </FormLabel>
                        <Textarea
                          value={formData.precauzioniSanitarie}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.precauzioniSanitarie && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.precauzioniSanitarie}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="comeSeiVenutoConoscenza"
                        isRequired
                        isInvalid={Boolean(errors.comeSeiVenutoConoscenza)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Come Sei Venuto a Conoscenza
                        </FormLabel>
                        <Select
                          placeholder="Seleziona opzione"
                          value={formData.comeSeiVenutoConoscenza}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        >
                          {options.comeSeiVenutoConoscenza.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </Select>
                        {errors.comeSeiVenutoConoscenza && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.comeSeiVenutoConoscenza}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="interessi"
                        isRequired
                        isInvalid={Boolean(errors.interessi)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Interessi
                        </FormLabel>
                        <CheckboxGroup
                          value={formData.interessi}
                          onChange={handleInteressiChange}
                        >
                          <Stack spacing={2} direction="column">
                            {options.interessi.map((option) => (
                              <Checkbox
                                key={option}
                                value={option}
                                colorScheme="teal"
                              >
                                {option}
                              </Checkbox>
                            ))}
                          </Stack>
                        </CheckboxGroup>
                        {errors.interessi && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.interessi}
                          </Text>
                        )}
                      </FormControl>

                      <Divider />
                      <TermsConditions />
                      <FormControl
                        mb={3}
                        id="autorizzazioneFotografie"
                        isInvalid={Boolean(errors.autorizzazioneFotografie)}
                      >
                        <Checkbox
                          id="autorizzazioneFotografie"
                          isChecked={formData.autorizzazioneFotografie}
                          onChange={handleChange}
                          colorScheme="teal"
                        >
                          <Text
                            display="inline"
                            color={formTextColor}
                            borderColor="blue.400"
                          >
                            Autorizzazione Fotografie
                          </Text>
                          <Tooltip
                            label="Consente l'utilizzo e la pubblicazione delle tue fotografie per scopi di archivio e documentazione delle attività."
                            fontSize="sm"
                            hasArrow
                          >
                            <Text
                              as="span"
                              ml={2}
                              color="gray.500"
                              cursor="pointer"
                            >
                              ?
                            </Text>
                          </Tooltip>
                        </Checkbox>
                        {errors.autorizzazioneFotografie && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.autorizzazioneFotografie}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="consensoPubblicazione"
                        isInvalid={Boolean(errors.consensoPubblicazione)}
                      >
                        <Checkbox
                          id="consensoPubblicazione"
                          isChecked={formData.consensoPubblicazione}
                          onChange={handleChange}
                          colorScheme="teal"
                        >
                          <Text
                            display="inline"
                            color={formTextColor}
                            borderColor="blue.400"
                          >
                            Consenso Pubblicazione
                          </Text>
                          <Tooltip
                            label="Acconsenti alla pubblicazione delle fotografie e contenuti multimediali quali audio e video sul web e sui social."
                            fontSize="sm"
                            hasArrow
                          >
                            <Text
                              as="span"
                              ml={2}
                              color="gray.500"
                              cursor="pointer"
                            >
                              ?
                            </Text>
                          </Tooltip>
                        </Checkbox>
                        {errors.consensoPubblicazione && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.consensoPubblicazione}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="sendNewsletter"
                        isInvalid={Boolean(errors.sendNewsletter)}
                      >
                        <Checkbox
                          id="sendNewsletter"
                          isChecked={formData.sendNewsletter}
                          onChange={handleChange}
                          borderColor="blue.300"
                        >
                          <Text
                            display="inline"
                            color={formTextColor}
                            borderColor="blue.400"
                          >
                            Iscriviti alla newsletter di CIL!
                          </Text>
                          <Tooltip
                            label="Rimani aggiornato su tutti i nostri eventi e iniziative."
                            fontSize="sm"
                            hasArrow
                          >
                            <Text
                              as="span"
                              ml={2}
                              color="gray.500"
                              cursor="pointer"
                            >
                              ?
                            </Text>
                          </Tooltip>
                        </Checkbox>
                        {errors.sendNewsletter && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="center"
                            pt={2}
                          >
                            {errors.sendNewsletter}
                          </Text>
                        )}
                      </FormControl>
                      <FormControl
                        mb={3}
                        id="terminiCondizioni"
                        isInvalid={Boolean(errors.terminiCondizioni)}
                      >
                        <Checkbox
                          id="terminiCondizioni"
                          isChecked={formData.terminiCondizioni}
                          onChange={handleChange}
                          colorScheme="teal"
                        >
                          <Text color={formTextColor} borderColor="blue.400">
                            Termini e Condizioni
                          </Text>
                        </Checkbox>
                        {errors.terminiCondizioni && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.terminiCondizioni}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="data"
                        isRequired
                        isInvalid={Boolean(errors.data)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Data
                        </FormLabel>
                        <Input
                          type="date"
                          value={formData.data}
                          isReadOnly
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.data && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.data}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="luogo"
                        isRequired
                        isInvalid={Boolean(errors.luogo)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Luogo
                        </FormLabel>
                        <Input
                          type="text"
                          value={formData.luogo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          color={formTextColor}
                          borderColor="blue.400"
                        />
                        {errors.luogo && (
                          <Text
                            color="red.500"
                            fontSize="sm"
                            textAlign="right"
                            pt={2}
                          >
                            {errors.luogo}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        mb={3}
                        id="firma"
                        isRequired
                        isInvalid={Boolean(errors.firma)}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Firma
                        </FormLabel>
                        <SignatureCanvas
                          ref={sigCanvas}
                          penColor={useColorModeValue('black', 'white')}
                          canvasProps={{
                            style: {
                              width: '100%',
                              height: '150px',
                              border: '1px solid #dddddd',
                              borderRadius: '8px',
                              backgroundColor: useColorModeValue(
                                'white',
                                'gray.700'
                              ),
                            },
                            className: 'sigCanvas',
                          }}
                          onEnd={() => {
                            if (touched.firma) {
                              const fieldErr = validateField(
                                'firma',
                                formData.firma
                              );
                              setErrors((prev) => ({
                                ...prev,
                                firma: fieldErr,
                              }));
                            }
                          }}
                        />
                        <Button
                          mt={2}
                          mb={2}
                          width="full"
                          onClick={clearSignature}
                          size="sm"
                          colorScheme="teal"
                        >
                          Ripristina Firma
                        </Button>
                        {errors.firma && (
                          <Text
                            textAlign="center"
                            color="red.500"
                            fontSize="sm"
                          >
                            {errors.firma}
                          </Text>
                        )}
                      </FormControl>
                    </>
                  )}
                </>
              )}

              <HStack spacing={4} justify="space-between" mt={4}>
                {step > 0 && !socioCreated?.documentId ? (
                  <Button
                    maxWidth={{ base: '120px', md: '180px' }}
                    onClick={handleBack}
                    variant="ghost"
                    _active={{ transform: 'scale(.98)' }}
                    _hover={{ bg: 'brand.300', color: 'white' }}
                    border="1px solid var(--chakra-colors-blue-400)"
                    size="md"
                    width="full"
                    isDisabled={loading}
                  >
                    Indietro
                  </Button>
                ) : (
                  <span />
                )}
                {step < totalSteps && (
                  <Button
                    maxWidth={{ base: '120px', md: '180px' }}
                    size="md"
                    width="full"
                    bg="brand.100"
                    _active={{ transform: 'scale(.98)' }}
                    _hover={{ bg: 'brand.300', color: 'white' }}
                    onClick={handleNext}
                    isDisabled={loading || !isFormValid || emailError}
                    isLoading={loading || emailLoading}
                    data-testid={
                      step === totalSteps - 1
                        ? 'tesseramento-form-submit'
                        : undefined
                    }
                  >
                    {step === totalSteps - 1 ? 'Conferma' : 'Avanti'}
                  </Button>
                )}
              </HStack>
              <Divider />
              <Flex justifyContent="flex-end">
                <Text
                  mt={-1}
                  color="blue.400"
                  fontSize="sm"
                  cursor="pointer"
                  _hover={{ color: 'blue.300', textDecoration: 'underline' }}
                  _active={{ transform: 'scale(0.98)' }}
                  onClick={handleHelpRequest}
                >
                  Hai bisogno di aiuto?
                </Text>
              </Flex>

              {Boolean(emailError) && (
                <Alert status="error" mt={4}>
                  <AlertIcon />
                  <AlertDescription>
                    Questo indirizzo risulta gia registrato, clicca su{' '}
                    <b>Login</b> per accedere.
                  </AlertDescription>
                </Alert>
              )}
              {submissionStatus === 'error' && (
                <Alert status="error" mt={4}>
                  <AlertIcon />
                  <AlertTitle>Errore!</AlertTitle>
                  <AlertDescription>
                    Si è verificato un errore durante il tesseramento.
                  </AlertDescription>
                </Alert>
              )}
            </VStack>
          </form>
        </>
      )}
      {isHelpModalOpen && (
        <HelpSupport
          isOpen={isHelpModalOpen}
          email={formData.email}
          onClose={onHelpSupportModalClose}
        />
      )}
    </Box>
  );
};

export default TesseramentoForm;
